
  <div class="col-md-12">
    <h3 class="colorPrincipal">{{title}}</h3>
  </div>

<!--<input type="file" capture="camera" accept="image/*" id="cameraInput" name="cameraInput"
       (change)="_takePicture($event)" #file hidden >-->
  <input type="file" accept="image/*" id="cameraInput" name="cameraInput"
         (change)="_takePicture($event)" #file hidden >

  <div class="col-md-12 centrado">
    <div *ngIf="!model" class="card borderSecondary height150 maxW400">
      <div class=" centrado nomargin">
        <img *ngIf="!model" class="imgLogoMini" [src]="defaultBackground" (click)="file.click()">
        <img *ngIf="model && url" class="imgLogoMini " [src]="url" (click)="file.click()">
      </div>
    </div>
  </div>
  <div *ngIf="model && url" class="card borderSecondary fullWidth height150 maxW400 right5" >
    <img class="cardPictureCamera imgLogo centrado" [src]="url" (click)="file.click()" >
  </div>

